import { notification } from "antd";
// import "antd/dist/antd.min.css";

const appNotification = (
  description,
  title = "Notification",
  type = "info"
) => {
  notification[type]({
    message: title,
    description: description,
  });
};

export default appNotification;
